class scanSelectionModalCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger) {
        $scope.totalMoney = 0
        $scope.scanListData = []
        // 字典字段
        httpRequest.get_dictByTypeArr(['ivat_inv_type', 'ivat_invoice_status']).then((res) => {
            $scope.dictionary = res.data.value
            $scope.dictionary.ivat_inv_type.push({
                enumCode: '-1',
                enumName: '未识别发票类型',
            })
        })
        setTimeout(() => {
            $('#QRCode-auto-focus').on('focusout', () => {
                setTimeout(() => {
                    $('#QRCode-auto-focus').focus()
                }, 10)
            })
        })
        // 扫描枪
        document.onkeydown = (e) => {
            if (e.keyCode == 13) {
                if (!$scope.qrCodeText) {
                    return logger.logError('没有扫描到数据')
                }
                httpRequest.get_getInvoiceByGun($scope.qrCodeText).then((res) => {
                    if (res.data.value) {
                        let scanInvoie = res.data.value
                        let existFlag = $scope.scanListData.some((x) => {
                            return (x.invoiceCode == scanInvoie.invoiceCode && x.invoiceNumber == scanInvoie.invoiceNumber)
                        })
                        if (existFlag) {
                            scanInvoie.hitFlag = '0'
                            scanInvoie.hitMsg = '重复扫描发票'
                        }
                        $scope.scanListData = $scope.scanListData.concat(scanInvoie)
                        $scope.caculateMoney()
                    } else {
                        logger.logError('二维码格式有误，请扫描发票二维码！')
                    }
                })
                $scope.qrCodeText = ''
            }
        }
        $scope.cancel = () => {
            $scope.scanListData = []
            $uibModalInstance.close()
        }

        $scope.ok = () => {
            if ($scope.scanListData.length) {
                $scope.scanListData.forEach(item => {
                    item.effectiveTaxamt = item.totalTaxamt || 0
                    item.invoiceStatus = 0
                })
                $uibModalInstance.close($scope.scanListData)
            } else {
                $uibModalInstance.close()
            }
        }

        $scope.$watch('scanListData', (newValue, oldValue) => {
            $scope.totalMoney = 0
            if (newValue && newValue.length > 0) {
                newValue.forEach((e) => {
                    $scope.totalMoney += e.totalAmt ? e.totalAmt : 0
                })
                $scope.btnDisabledFlag = newValue.some((x) => {
                    return x.hitFlag == '0'
                })
            }
        }, true)

        $scope.delInvoice = function (item,index) { 
            console.log(index)
            $scope.scanListData.splice(index, 1)
        }

        $scope.caculateMoney = function () {
            $scope.totalMoney = 0
            $scope.scanListData.forEach((i) => {
                $scope.totalMoney += i.totalAmt ? i.totalAmt : 0
            })
        }
    }
}

scanSelectionModalCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger']
export default scanSelectionModalCtrl


// WEBPACK FOOTER //
// ./src/components/deductionCheck/scanSelectionModalCtrl.js